<!-- Copyright (c) 2023, Alix Mougenot (Au pied des Arbres), alix.mougenot@gmail.com -->
<!-- See license file. -->
<script setup lang="ts">
import { inject } from "vue";
import { healthCentersKey } from "@/logic/provide";
import HealthCenterList from "@/components/actors/HealthCenterList.vue";
import NavigationManager from "@/components/navigation/NavigationManager.vue";
import Navigation from "@/components/navigation/Navigation.vue";

const healthCenters = inject(healthCentersKey);
</script>

<template>
  <div v-if="!healthCenters || healthCenters.list.length === 0"></div>
  <NavigationManager v-else>
    <Navigation navKey="Base des centres"> <HealthCenterList /> </Navigation>
  </NavigationManager>
</template>

<style lang="scss"></style>
